export default function getAddressComponentFromPosition(lng, lat) {
  const Geocoder = new window.google.maps.Geocoder();
  return new Promise((resolve) => {
    Geocoder.geocode({ location: { lat: parseFloat(lat), lng: parseFloat(lng) } }, (results) => {
      if (!results || results.length === 0) {
        resolve(null);
        return;
      }

      resolve(results);
      // resolve(results[0].formatted_address);
    });
  });
}
